import styled from 'styled-components'
import { useModuleContext } from '../contexts/module'
import Link from 'next/link'
import { useBackNavigation } from '@hooks'
// import { uploadTransformationUrl } from '@dmi-mch/utils'
// import { cloudinary } from '@constants'
import { formatRoomLink } from '@utils'



const GalleryImage = () => {
  const { state: { artworkInformation } } = useModuleContext()
  const {
    galleryImage,
    isGallery,
    showEnded,
    galleryId,
    gallerySlug,
    eventId,
    roomTitle
    // gallery
  } = artworkInformation || {}

  const { keys, set } = useBackNavigation()

  return (
    <>
      {isGallery && galleryImage && (
        <div className=''>
          <Link legacyBehavior href='/gallery' as={showEnded ? `/catalog/gallery/${galleryId}/${gallerySlug}` : formatRoomLink(eventId, roomTitle, null)}>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a className='d-inline-block'>
              <GalleryImageContainer visible={galleryImage}
                onClick={() => set(keys.OVR_INTRO.INSIDE_ROOM_TO_ARTWORK)}
              >
                {/* <Image
                  src={uploadTransformationUrl(galleryImage, 'q_auto,h_200,w_200,dpr_auto,c_fit',
                    { 'transformUrl': cloudinary.throughCloudfront })}
                  alt={gallery}
                /> */}
              </GalleryImageContainer>
            </a>
          </Link>
        </div>
      )}
    </>
  )
}

const GalleryImageContainer = styled.div<any>`
  border: 1px solid var(--bs-mch-galleries);
  width: 100px;
  height: 100px;
`

export default GalleryImage